import React from 'react'
import { Grid, MainWrapper } from '../../../index'
import { useConfig } from 'msp-integrations'
import { NavFooter } from './Footer.partials'
import * as T from './Footer.types'
import { getStyles } from './Footer.styles'

const Footer = ({
  i18nProp,
  logoComponent,
  preFooterMobileSlot,
  firstColumnSlot,
  secondColumnSlot,
  thirdColumnSlot,
  fourthColumnSlot,
  postFooterMobileSlot,
  navFooterSlot
}: T.FooterProps) => {
  const config = useConfig()
  const S = getStyles(config)

  return (
    <div className={S.FooterMainWrapper}>
      <MainWrapper>
        <div className={S.FooterSubWrapper}>{logoComponent}</div>
        {preFooterMobileSlot}
        <Grid wrapperStyles={S.GridWrapperStyles}>
          {firstColumnSlot}
          {secondColumnSlot}
          {thirdColumnSlot}
          {fourthColumnSlot}
        </Grid>
        {postFooterMobileSlot}
        <NavFooter i18nProp={i18nProp} style={S}>
          {navFooterSlot}
        </NavFooter>
      </MainWrapper>
    </div>
  )
}

export default Footer
